import { makeStyles } from 'tss-react/mui';

// eslint-disable-next-line max-lines-per-function
export const useChainDescriptionStyles = makeStyles()(theme => {
  const premiumChip = {
    height: 20,
    display: 'flex',
    alignItems: 'center',
    whiteSpace: 'nowrap' as const,
    overflow: 'hidden',
    paddingRight: 0,
    paddingLeft: 0,

    [theme.breakpoints.down('xs')]: {
      padding: theme.spacing(1),
      height: 16,
      borderRadius: theme.shape.borderRadiusXs,
    },

    span: {
      overflow: 'hidden',
      textOverflow: 'ellipsis',
      fontSize: 12,

      [theme.breakpoints.down('xs')]: {
        padding: 0,
        fontSize: 9,
        lineHeight: 1,
      },
    },
  };

  return {
    chainDescriptionRoot: {
      display: 'flex',
      alignItems: 'center',
      gap: theme.spacing(3),
    },
    description: {
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      overflow: 'hidden',
    },
    top: {
      display: 'flex',
      alignItems: 'flex-end',
      margin: 0,
    },
    topWithMargin: {
      marginBottom: theme.spacing(2.5),
      [theme.breakpoints.down('sm')]: {
        marginBottom: 0,
      },
    },
    chainName: {
      fontSize: 28,
      lineHeight: 1,

      [theme.breakpoints.down('sm')]: {
        fontSize: 16,
      },
    },
    chainNameSmall: {
      fontSize: 16,
      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        flexShrink: 0,
      },
    },
    coinName: {
      fontWeight: 400,
      fontSize: 20,
      display: 'flex',
      marginLeft: theme.spacing(2),
      lineHeight: 1.1,

      [theme.breakpoints.down('sm')]: {
        fontSize: 14,
        lineHeight: 1,
      },
    },
    coinNameSmall: {
      fontSize: 14,
      marginLeft: theme.spacing(1),
    },
    archiveLabel: {
      height: 20,
      display: 'flex',
      alignItems: 'center',
      borderRadius: theme.shape.borderRadiusSm,
      fontSize: 12,
      fontWeight: 500,
      lineHeight: '135%',

      [theme.breakpoints.down('xs')]: {
        height: 16,
        padding: theme.spacing(1),
        fontSize: 9,
        lineHeight: 1,
        borderRadius: theme.shape.borderRadiusXs,
      },
    },
    chips: {
      display: 'flex',
      gap: theme.spacing(1),
      marginTop: theme.spacing(1),
      flexWrap: 'wrap',
    },
    premiumChip: premiumChip,
    tooltip: {
      borderBottom: `1px dashed ${theme.palette.primary.light}`,
    },
    tooltipContent: {
      backgroundColor: theme.palette.surface.overlay,
    },
    statusItem: {
      display: 'flex',
      alignItems: 'center',
      color: theme.palette.text.immutable,
    },
    dot: {
      display: 'flex',
      alignItems: 'center',
      '&::after': {
        content: '""',
        width: 2,
        height: 2,
        borderRadius: '50%',
        backgroundColor: theme.palette.text.secondary,
      },
    },
    statusText: {
      lineHeight: 1.7,
    },
  };
});
